export default __webpack_public_path__ + "static/automateFollowUpGraphic-db12639a20583afc3c8e3cf7ee5d372d.svg";